<template>
  <div>
    <modal-box :is-active="isModalActive" :trash-object-name="trashObjectName" @confirm="trashConfirm"
               @cancel="trashCancel"/>
     <b-table
      :loading="isLoading"
      paginated

      backend-pagination
      @page-change="onPageChange"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      backend-sorting
      :default-sort-direction="defaultSortOrder"
      :default-sort="[sortField, sortOrder]"
      @sort="onSort"
      :per-page="perPage"
      :striped="true"
      :hoverable="true"
      :current-page="currentPage"
      :data="dashboard"
      cell-class="cell-class"
    >

      <template slot-scope="props">
        <!-- <b-table-column class="has-no-head-mobile is-image-cell">
          <div class="image">
            <img :src="props.row.file" class="is-rounded">
          </div>
        </b-table-column> -->
        <b-table-column label="Name" field="name">
          {{ props.row.name }}
        </b-table-column>
        <!-- <b-table-column label="Email" field="email">
          {{ props.row.email }}
        </b-table-column> -->
        <b-table-column label="Total Questions " field="Total Questions" sortable>
          {{ props.row.totalQuestion }}
        </b-table-column>
      </template>

      <section class="section" slot="empty">
        <div class="content has-text-grey has-text-centered">
          <template v-if="isLoading">
            <p>
              <b-icon icon="dots-horizontal" size="is-large"/>
            </p>
            <p>Fetching data...</p>
          </template>
          <template v-else>
            <p>
              <b-icon icon="emoticon-sad" size="is-large"/>
            </p>
            <p>Nothing's there&hellip;</p>
          </template>
        </div>
      </section>
    </b-table>
  </div>
</template>

<script>
import axios from 'axios'
import ModalBox from '@/components/ModalBox'

export default {
  name: 'ClientsTableSample',
  components: { ModalBox },
  props: {
    dataUrl: {
      type: String,
      default: null
    },
    checkable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isModalActive: false,
      isEditModalActive: false,
      trashObject: null,
      editObject: null,
      clients: [],
      isLoading: false,
      paginated: true,
      perPage: 10,
      currentPage: 1,
      totalItems: 60,
      sortField: 'totalQuestion',
      sortOrder: '-',
      defaultSortOrder: '-',
    }
  },
  computed: {
    trashObjectName () {
      if (this.trashObject) {
        return this.trashObject.name
      }

      return null
    },
     dashboard() {
      return this.$store.state.dashboard.questionManager;
    }
  },
  mounted () {
    this.isLoading = true;
    this.fetchQuestionManagers();
    // if (this.dataUrl) {
    //   this.isLoading = true
    //   axios
    //     .get(this.dataUrl)
    //     .then(r => {
    //       this.isLoading = false
    //       if (r.data && r.data.data) {
    //         if (r.data.data.length > this.perPage) {
    //           this.paginated = true
    //         }
    //         this.clients = r.data.data
    //       }
    //     })
    //     .catch(e => {
    //       this.isLoading = false
    //       this.$buefy.toast.open({
    //         message: `Error: ${e.message}`,
    //         type: 'is-danger'
    //       })
    //     })
    // }
  },
  methods: {
    fetchQuestionManagers() {
      const sortBy = this.sortOrder + this.sortField;
      this.$store
        .dispatch('dashboard/getQuestionManagers', {
          filter: {
            page: this.currentPage,
            limit: 10,
            sort: sortBy,
          },
        })
        .then(() => {
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$buefy.toast.open({
            message: `Error: ${err.message}`,
            type: 'is-danger',
          });
        });
    },
    trashModal (trashObject) {
      this.trashObject = trashObject
      this.isModalActive = true
    },
    trashConfirm () {
      this.isModalActive = false
      this.$buefy.snackbar.open({
        message: 'Confirmed',
        queue: false
      })
    },
    trashCancel () {
      this.isModalActive = false
    }
  }
}
</script>

<style scoped>

</style>